export const environment = {
  production: false,
  config: {
    local: {
      _site: 'https://app.dev.clubeconecta.app.br/',
      // urlApiPadrao: 'https://api.clubeconecta.app.br/',
      urlApiPadrao: 'http://localhost:3012/',
      urlApiProcessamento: 'http://localhost:3014/',
      //urlApiPadrao: 'https://api.portalacao.com.br/',
      urlMedia: 'http://localhost:3012/media-volume/',
      X_TOKEN_API: '262e4801adb5dfe5611a4a83c68365a591f14c48',
      debugMode: 'info'
    },
    dev: {
      _site: 'https://app.dev.clubeconecta.app.br/',
      urlApiPadrao: 'https://api.dev.clubeconecta.app.br/',
      urlApiProcessamento: 'https://api-processamento.dev.icons4u.com.br/',
      urlMedia: 'https://media.dev.clubeconecta.app.br/',
      X_TOKEN_API: '262e4801adb5dfe5611a4a83c68365a591f14c48',
      debugMode: 'info'
    },
    hom: {
      _site: 'https://app.hom.clubeconecta.app.br/',
      urlApiPadrao: 'https://api.clubeconecta.app.br/',
      urlApiProcessamento: 'https://api-processamento.dev.icons4u.com.br/',
      urlMedia: 'https://media.hom.clubeconecta.app.br/',
      X_TOKEN_API: '262e4801adb5dfe5611a4a83c68365a591f14c48',
      debugMode: 'off'
    },
    prod: {
      _site: 'https://app.clubeconecta.app.br/',
      urlApiPadrao: 'https://api.clubeconecta.app.br/',
      urlApiProcessamento: 'https://api-processamento.icons4u.com.br/',
      urlMedia: 'https://media.clubeconecta.app.br/',
      X_TOKEN_API: '262e4801adb5dfe5611a4a83c68365a591f14c48',
      debugMode: 'off'
    }
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.